import { render, staticRenderFns } from "./leftBox.vue?vue&type=template&id=343ee990&scoped=true&"
import script from "./leftBox.vue?vue&type=script&lang=js&"
export * from "./leftBox.vue?vue&type=script&lang=js&"
import style0 from "./leftBox.vue?vue&type=style&index=0&id=343ee990&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ee990",
  null
  
)

export default component.exports